/**
 * jm-cart-drawer.js
 * Replaces the Horizon cart drawer content with the JM app session cart.
 * Fetches from api/cart.php, renders items, handles checkout.
 */

(function () {
  'use strict';

  var CART_ENDPOINT = 'https://app.devpartners.co.uk/blackwells-jewellery-mechanic/api/cart.php';
  var CHECKOUT_ENDPOINT = 'https://app.devpartners.co.uk/blackwells-jewellery-mechanic/api/checkout.php';

  // ── Find the JM cart container injected into the drawer ──────
  function getContainer() {
    return document.getElementById('jm-drawer-cart');
  }

  // ── Format money ─────────────────────────────────────────────
  function fmt(amount) {
    return '\u00a3' + parseFloat(amount).toFixed(2);
  }

  // ── Escape HTML ──────────────────────────────────────────────
  function esc(str) {
    var d = document.createElement('div');
    d.textContent = String(str);
    return d.innerHTML;
  }

  // ── Render cart into the drawer container ────────────────────
  function renderCart(data, discount, coupon) {
    var container = getContainer();
    if (!container) return;

    if (!data.items || data.items.length === 0) {
      container.innerHTML =
        '<div class="jm-drawer-empty">' +
          '<p>Your cart is empty.</p>' +
        '</div>';
      return;
    }

    var itemsHtml = data.items.map(function (item) {
      var propsHtml = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          if (key.charAt(0) === '_') return;
          var val = String(item.properties[key]);
          var isImage = /^https?:\/\/.+\.(jpg|jpeg|png|webp|gif|heic|svg)(\?.*)?$/i.test(val);
          if (!isImage) {
            propsHtml += '<div class="jm-drawer-prop"><span class="jm-drawer-prop-key">' + esc(key) + ':</span> ' + esc(val) + '</div>';
          }
        });
      }
      var imgHtml = item.image
        ? '<img src="' + esc(item.image) + '" alt="" class="jm-drawer-item-img">'
        : '<div class="jm-drawer-item-img jm-drawer-item-img--placeholder">\ud83d\udc8e</div>';

      return '<div class="jm-drawer-item" data-item-id="' + esc(item.id) + '">' +
        imgHtml +
        '<div class="jm-drawer-item-info">' +
          '<div class="jm-drawer-item-title">' + esc(item.product_title) + '</div>' +
          (propsHtml ? '<div class="jm-drawer-item-props">' + propsHtml + '</div>' : '') +
          '<button class="jm-drawer-remove" data-item-id="' + esc(item.id) + '">Remove</button>' +
        '</div>' +
        '<div class="jm-drawer-item-price">' + fmt(item.price) + '</div>' +
      '</div>';
    }).join('');

    var html =
      '<div class="jm-drawer-items">' + itemsHtml + '</div>' +
      '<div class="jm-drawer-footer">' +
        '<div class="jm-drawer-total">' +
          '<span>' + (discount || (coupon && coupon.type !== 'BXGY') ? 'Subtotal' : 'Total') + '</span>' +
          '<span>' + fmt(data.total) + '</span>' +
        '</div>' +
        (discount ? (
          '<div class="jm-drawer-total" style="color:#10b981;font-size:13px;">' +
            '<span>Subscription discount (' + discount.percent + '% off)</span>' +
            '<span>\u2212' + fmt(data.total * discount.percent / 100) + '</span>' +
          '</div>' +
          '<div class="jm-drawer-total" style="font-weight:700;">' +
            '<span>Total</span>' +
            '<span>' + fmt(data.total * (1 - discount.percent / 100)) + '</span>' +
          '</div>'
        ) : coupon ? (
          '<div class="jm-drawer-total" style="color:#10b981;font-size:13px;display:flex;justify-content:space-between;align-items:center;">' +
            '<span>' + esc(coupon.title) + ' (' + esc(coupon.code) + ')</span>' +
            '<button id="jm-drawer-remove-coupon" style="background:none;border:none;cursor:pointer;font-size:11px;color:#888;text-decoration:underline;padding:0;">Remove</button>' +
          '</div>' +
          (coupon.type === 'BXGY' ? (
            '<div class="jm-drawer-total" style="font-weight:700;"><span>Total</span><span>' + fmt(data.total) + '</span></div>'
          ) : coupon.type === 'PERCENTAGE' ?
            '<div class="jm-drawer-total" style="font-weight:700;"><span>Total</span><span>' + fmt(data.total * (1 - coupon.value / 100)) + '</span></div>'
          :
            '<div class="jm-drawer-total" style="font-weight:700;"><span>Total</span><span>' + fmt(Math.max(0, data.total - coupon.value)) + '</span></div>'
          )
        ) : (
          '<div class="jm-drawer-total" style="font-weight:700;">' +
            '<span>Total</span>' +
            '<span>' + fmt(data.total) + '</span>' +
          '</div>'
        )) +
        (!discount ? (
        '<div class="jm-drawer-coupon" style="margin:12px 0;">' +
          '<div style="display:flex;gap:8px;">' +
            '<input type="text" id="jm-drawer-coupon-input" placeholder="Discount code" style="flex:1;padding:8px 10px;border:1px solid #ddd;border-radius:4px;font-size:13px;font-family:inherit;">' +
            '<button id="jm-drawer-coupon-apply" style="padding:8px 14px;background:#1a1a1a;color:#fff;border:none;border-radius:4px;font-size:13px;cursor:pointer;white-space:nowrap;">Apply</button>' +
          '</div>' +
          '<div id="jm-drawer-coupon-msg" style="font-size:12px;margin-top:4px;display:none;"></div>' +
        '</div>'
      ) : '') +
      '<p class="jm-drawer-note">Your selections will be reviewed by our jewellers before work begins.</p>' +
        '<button class="jm-drawer-checkout-btn" id="jm-drawer-checkout">Proceed to Checkout</button>' +
        '<div class="jm-drawer-checkout-error" id="jm-drawer-error" style="display:none"></div>' +
      '</div>';

    container.innerHTML = html;

    // Bind remove buttons
    container.querySelectorAll('.jm-drawer-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeItem(btn.getAttribute('data-item-id'));
      });
    });

    // Bind coupon apply button
    var couponApply = document.getElementById('jm-drawer-coupon-apply');
    var couponInput = document.getElementById('jm-drawer-coupon-input');
    var couponMsg   = document.getElementById('jm-drawer-coupon-msg');
    if (couponApply && couponInput) {
      couponApply.addEventListener('click', function() {
        var code = couponInput.value.trim();
        if (!code) return;
        couponApply.disabled = true;
        couponApply.textContent = '\u2026';
        fetch(CART_ENDPOINT + '?action=apply_coupon', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code: code }),
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          couponApply.disabled = false;
          couponApply.textContent = 'Apply';
          if (data.success) {
            if (data.bxgy && data.free_products && data.free_products.length > 0) {
              renderFreeProductPicker(data.free_products);
            } else {
              loadCart();
            }
          } else {
            if (couponMsg) {
              couponMsg.style.display = 'block';
              couponMsg.style.color = '#ef4444';
              couponMsg.textContent = data.error || 'Invalid code.';
            }
          }
        })
        .catch(function() { couponApply.disabled = false; couponApply.textContent = 'Apply'; });
      });
    }

    // Bind remove coupon button
    var removeCoupon = document.getElementById('jm-drawer-remove-coupon');
    if (removeCoupon) {
      removeCoupon.addEventListener('click', function() {
        fetch(CART_ENDPOINT + '?action=remove_coupon', { method: 'POST', credentials: 'include' })
          .then(function() { loadCart(); });
      });
    }

    // Bind checkout button
    var checkoutBtn = document.getElementById('jm-drawer-checkout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        handleCheckout(checkoutBtn);
      });
    }
  }

  // ── BXGY Free product picker (mini cart) ─────────────────────
  function renderFreeProductPicker(products) {
    var container = getContainer();
    if (!container) return;

    var productsHtml = products.map(function(p) {
      var variantsHtml = p.variants.length === 1
        ? '<input type="hidden" class="jm-bxgy-variant-select" data-product-title="' + esc(p.title) + '" data-product-image="' + esc(p.image) + '" data-product-numeric-id="' + esc(p.numeric_id) + '" value="' + esc(p.variants[0].id) + '" data-variant-title="' + esc(p.variants[0].title) + '" data-variant-numeric-id="' + esc(p.variants[0].numeric_id) + '">'
        : '<select class="jm-bxgy-variant-select" data-product-title="' + esc(p.title) + '" data-product-image="' + esc(p.image) + '" data-product-numeric-id="' + esc(p.numeric_id) + '" style="width:100%;margin-top:4px;padding:4px 6px;font-size:12px;border:1px solid #ddd;border-radius:3px;">' +
            p.variants.map(function(v) {
              return '<option value="' + esc(v.id) + '" data-variant-title="' + esc(v.title) + '" data-variant-numeric-id="' + esc(v.numeric_id) + '">' + esc(v.title) + '</option>';
            }).join('') +
          '</select>';
      return '<div class="jm-bxgy-product" style="display:flex;align-items:center;gap:10px;padding:10px 0;border-bottom:1px solid #f0f0f0;">' +
        (p.image ? '<img src="' + esc(p.image) + '" style="width:48px;height:48px;object-fit:cover;border-radius:4px;flex-shrink:0;">' : '<div style="width:48px;height:48px;background:#f5f5f5;border-radius:4px;flex-shrink:0;"></div>') +
        '<div style="flex:1;min-width:0;">' +
          '<div style="font-size:13px;font-weight:500;">' + esc(p.title) + '</div>' +
          '<div style="font-size:12px;color:#10b981;">Free</div>' +
          variantsHtml +
        '</div>' +
        '<button class="jm-bxgy-select-btn" style="padding:6px 12px;background:#1a1a1a;color:#fff;border:none;border-radius:4px;font-size:12px;cursor:pointer;white-space:nowrap;">Select</button>' +
      '</div>';
    }).join('');

    container.innerHTML =
      '<div style="padding:16px 0;">' +
        '<div style="font-size:14px;font-weight:600;margin-bottom:4px;">Choose your free item</div>' +
        '<div style="font-size:12px;color:#888;margin-bottom:12px;">Select one free product included with your discount code.</div>' +
        '<div id="jm-bxgy-products">' + productsHtml + '</div>' +
        '<button id="jm-bxgy-cancel" style="margin-top:12px;background:none;border:none;cursor:pointer;font-size:12px;color:#888;text-decoration:underline;padding:0;">Cancel</button>' +
      '</div>';

    container.querySelectorAll('.jm-bxgy-select-btn').forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        var row      = container.querySelectorAll('.jm-bxgy-product')[i];
        var selEl    = row.querySelector('.jm-bxgy-variant-select');
        var varId    = selEl.value;
        var varTitle = selEl.tagName === 'SELECT'
          ? selEl.options[selEl.selectedIndex].getAttribute('data-variant-title')
          : selEl.getAttribute('data-variant-title');
        var prodTitle = selEl.getAttribute('data-product-title');
        var prodImage = selEl.getAttribute('data-product-image');

        btn.disabled = true;
        btn.textContent = '\u2026';

        var varNumId  = selEl.tagName === 'SELECT'
          ? selEl.options[selEl.selectedIndex].getAttribute('data-variant-numeric-id')
          : selEl.getAttribute('data-variant-numeric-id');
        var prodNumId = selEl.getAttribute('data-product-numeric-id');

        fetch(CART_ENDPOINT + '?action=select_free_product', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            variant_id:          varId,
            variant_numeric_id:  varNumId  ? parseInt(varNumId,  10) : 0,
            product_numeric_id:  prodNumId ? parseInt(prodNumId, 10) : 0,
            variant_title:       varTitle,
            product_title:       prodTitle,
            product_image:       prodImage,
          }),
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.success) { loadCart(); }
          else { btn.disabled = false; btn.textContent = 'Select'; }
        })
        .catch(function() { btn.disabled = false; btn.textContent = 'Select'; });
      });
    });

    var cancelBtn = document.getElementById('jm-bxgy-cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function() {
        fetch(CART_ENDPOINT + '?action=remove_coupon', { method: 'POST', credentials: 'include' })
          .then(function() { loadCart(); });
      });
    }
  }

  // ── Fetch JM cart and render ─────────────────────────────────
  function loadCart() {
    var container = getContainer();
    if (!container) return;

    container.innerHTML = '<div class="jm-drawer-loading">Loading\u2026</div>';

    Promise.all([
      fetch(CART_ENDPOINT + '?action=get', { method: 'GET', credentials: 'include' }).then(function(r) { return r.json(); }),
      fetch(CART_ENDPOINT + '?action=discount', { method: 'GET', credentials: 'include' }).then(function(r) { return r.json(); }).catch(function() { return null; }),
      fetch(CART_ENDPOINT + '?action=get_coupon', { method: 'GET', credentials: 'include' }).then(function(r) { return r.json(); }).catch(function() { return null; })
    ])
      .then(function(results) {
        var cartData     = results[0];
        var discountData = results[1];
        var couponData   = results[2];
        var discount     = (discountData && discountData.discount) ? discountData.discount : null;
        var coupon       = (!discount && couponData && couponData.coupon) ? couponData.coupon : null;
        if (cartData.success) {
          // If a BXGY coupon is applied but no free item has been selected yet, show picker
          if (coupon && coupon.type === 'BXGY') {
            var hasFreeItem = cartData.items && cartData.items.some(function(i) { return i.is_free_bxgy; });
            if (!hasFreeItem && coupon.free_products && coupon.free_products.length > 0) {
              renderFreeProductPicker(coupon.free_products);
              return;
            }
          }
          renderCart(cartData, discount, coupon);
        } else {
          container.innerHTML = '<div class="jm-drawer-empty"><p>Your cart is empty.</p></div>';
        }
      })
      .catch(function () {
        container.innerHTML = '<div class="jm-drawer-empty"><p>Your cart is empty.</p></div>';
      });
  }

  // ── Remove item ──────────────────────────────────────────────
  function removeItem(itemId) {
    fetch(CART_ENDPOINT + '?action=remove', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ item_id: itemId }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.success) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { itemCount: data.count } }
          }));
          loadCart();
        }
      })
      .catch(function () {
        loadCart();
      });
  }

  // ── Handle checkout ──────────────────────────────────────────
  function handleCheckout(btn) {
    var errEl = document.getElementById('jm-drawer-error');
    btn.disabled = true;
    btn.textContent = 'Creating your order\u2026';
    if (errEl) errEl.style.display = 'none';

    fetch(CHECKOUT_ENDPOINT, {
      method: 'POST',
      credentials: 'include',
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.success && data.invoice_url) {
          fetch(CART_ENDPOINT + '?action=clear', {
            method: 'POST',
            credentials: 'include',
          }).finally(function () {
            window.location.href = data.invoice_url;
          });
        } else {
          if (errEl) {
            errEl.textContent = data.error || 'Something went wrong. Please try again.';
            errEl.style.display = 'block';
          }
          btn.disabled = false;
          btn.textContent = 'Proceed to Checkout';
        }
      })
      .catch(function () {
        if (errEl) {
          errEl.textContent = 'Network error. Please try again.';
          errEl.style.display = 'block';
        }
        btn.disabled = false;
        btn.textContent = 'Proceed to Checkout';
      });
  }

  // ── Sync cart count on every page load ──────────────────────
  function syncCartCount() {
    fetch(CART_ENDPOINT + '?action=get', {
      method: 'GET',
      credentials: 'include',
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data.success) return;
        var count = data.count || 0;

        sessionStorage.setItem('cart-count', JSON.stringify({
          value: String(count),
          timestamp: Date.now(),
        }));

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: count } }
        }));
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartCount);
  } else {
    syncCartCount();
  }

  function bindDrawerOpen() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    drawer.addEventListener('dialog:open', function () {
      loadCart();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindDrawerOpen);
  } else {
    bindDrawerOpen();
  }

  document.addEventListener('jm:cart:added', function () {
    loadCart();
  });

})();
